import SocialLinksMobileView from "./SocialLinksMobileView";
export default SocialLinksMobileView;
